import React from "react"
import { useSearchspringPage } from "@app/scripts/hooks/use-searchspring-page"

export function ResultFooter() {
  const { handleNextPage, isLastPage, pagination } = useSearchspringPage()

  if (!pagination) return null

  const progressPercent = Math.min(
    (pagination.end / pagination.totalResults) * 100,
    100
  )

  return (
    <div className="load-more--container">
      <p className="load-more--info">
        {pagination.end} out of {pagination.totalResults} products
      </p>

      <div className="load-more--progress-bar">
        <div
          className="load-more--progress-fill"
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      {!isLastPage ? (
        <button
          onClick={handleNextPage}
          className="load-more--button"
          disabled={isLastPage}
        >
          <span>Load More</span>
          <span className="load-more--button-underline"></span>
        </button>
      ) : null}
    </div>
  )
}
